var parent = require('../../es/instance/trim');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/trim.js
// module id = 579
// module chunks = 0 1